module.exports = __webpack_public_path__ + "img/xingz.10727e58.svg";